// extracted by mini-css-extract-plugin
export default {"genericCard":"Wq-z","inline":"Xq-z","mastercard":"Yq-z","discover":"Zq-z","visa":"_q-z","amex":"ar-z","active":"br-z"};